/* eslint-disable react/prefer-stateless-function */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Redirect } from 'react-router'
import classNames from 'classnames'
import { INTERNAL_SERVER_ERROR } from '../../server/lib/http-codes'
import ErrorFeature from '../components/error-feature'
import Spinner from '../components/spinner'
import TitleAndDescription from '../components/title-and-description'
import getDisplayName from '../helpers/get-display-name'
import { useEvolvedContext } from '../context'
import ErrorPage from './error'

// Because typescript doesn't like this function having no arg
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const identityMeta = _obj => ({})

const pagesHoc = (
  WrappedComponent,
  getMetaData = identityMeta,
  canonicalizeUrl
) => {
  const NewComponent = props => {
    const isEvolved = useEvolvedContext()
    const { centre, error, loading, redirect, brand } = props

    if (error) {
      return centre ? (
        <ErrorFeature
          status={error.code || INTERNAL_SERVER_ERROR}
          error={error}
        />
      ) : (
        <ErrorPage status={error.code} error={error} />
      )
    }

    if (loading) {
      // Loading page
      return <Spinner className={classNames({ brand })} />
    }

    if (redirect) {
      return <Redirect to={redirect} />
    }

    return (
      <Fragment>
        <TitleAndDescription
          getMetaData={getMetaData}
          canonicalizeUrl={canonicalizeUrl}
          isEvolved={isEvolved}
          {...props}
        />
        <WrappedComponent {...props} />
      </Fragment>
    )
  }
  NewComponent.displayName = `Page(${getDisplayName(WrappedComponent)})`
  NewComponent.propTypes = {
    error: PropTypes.object,
    loading: PropTypes.bool,
    redirect: PropTypes.string,
    centre: PropTypes.object,
    brand: PropTypes.bool,
  }
  return NewComponent
}

export default pagesHoc
